import { experience } from '@logto/schemas';

// NOTE: member の category・値は cowcamo-rails と揃えてある。一覧と命名の経緯は docs/tracking/README.md。
export type TrackingEvent = {
  category: string;
  action: string;
  label: string;
};

const memberCategory = 'member';
const signInLabel = 'signin';
const signUpLabel = 'signup';

const resolveScreen = (pathname: string) =>
  pathname.startsWith(`/${experience.routes.register}`) ? signUpLabel : signInLabel;

// 固定の値で送るイベントはここ、押した場所や接続先で値が変わるものは下の resolve 関数
export const trackingEvents = Object.freeze({
  signInWithMail: { category: memberCategory, action: 'signin_with_mail', label: signInLabel },
} satisfies Record<string, TrackingEvent>);

export const resolveSocialClickEvent = (
  pathname: string,
  connectorTarget: string
): TrackingEvent => ({
  category: memberCategory,
  action: `start_with_${connectorTarget}`,
  label: resolveScreen(pathname),
});

export const resolveSignUpCompleteEvent = (connectorTarget = 'unknown'): TrackingEvent => ({
  category: memberCategory,
  action: 'signup_complete',
  label: connectorTarget,
});
